import { assortMasterServiceItems } from '@/helpers/serviceCategory';
import { api_portalOfficeListing_filter } from '@/init/swagger';
import { SearchAppHomeType } from '@/schemas/SearchAppHomeSchema';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

type Props = {
  search: () => void;
  searchFilters: api_portalOfficeListing_filter[];
};

export const useLogic = ({ search, searchFilters }: Props) => {
  const [showMore, setShowMore] = useState(false);

  const { control, setValue, getValues } = useFormContext<SearchAppHomeType>();

  const filters = assortMasterServiceItems({ masterItems: searchFilters });

  const reduceInitialValue: {
    [key in string]: (typeof filters)['additionStatuses'];
  } = {};
  const additionStatuses = filters.additionStatuses.reduce((result, value) => {
    if (!value || !value.label) return result;

    const categoryName = value.label.replace('【', '').split('】')[0];
    const label = value.label.replace('【', '').split('】')[1];
    if (!result[categoryName]) {
      result[categoryName] = [];
    }
    result[categoryName].push({ ...value, label });
    return result;
  }, reduceInitialValue);

  const toggleCheckbox = ({ filtersKey }: { filtersKey: string }) => {
    const currentValue = getValues(`filters`) as Record<string, boolean>;
    const newValue = {
      ...currentValue,
      [filtersKey]: !currentValue[filtersKey],
    };
    setValue(`filters`, newValue);

    search();
  };

  const resetStationFilter = () => {
    // NOTE: ステーションに関するフィルターのみリセットする
    const stationFilterKeys = new Set<string>();
    searchFilters.forEach((f) => {
      if (f.category_id != null && f.id != null) {
        stationFilterKeys.add(`${f.category_id}_${f.id}`);
      }
    });

    const currentValue = getValues(`filters`) as Record<string, boolean>;
    const newValue = {
      ...currentValue,
    };
    stationFilterKeys.forEach((key) => {
      newValue[key] = false;
    });
    setValue(`filters`, newValue);

    setValue('is_no_addition', false);

    setValue('page', 1);

    search();
  };

  return {
    showMore,
    setShowMore,
    toggleCheckbox,
    resetStationFilter,
    control,
    filters,
    additionStatuses,
  };
};
